export default "/images/JoãoCruz.jpg?d093a029c1f8e53885085fa12245798a";